import React, { useEffect } from 'react'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '../../../components/Button'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import LinkButton from '../../../components/LinkButton'
import Paper from '@material-ui/core/Paper'
import { confirmForgotPasswordEmail, getTeamBackgroundByEmail, getTeamLogoByEmail, resetWrongCodeError } from '../../../redux/actions'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector, wrongCodeErrorSelector } from '../../../redux/selectors'
import { connect } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, passwordMatch, passwordStrength, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import { FormHelperText } from '@material-ui/core'
import FormPassword from '../../../components/FormPassword'

const formName = 'forgotpassword';
const requiredValidator = required
const emailValidator = email
const passwordStrengthValidator = passwordStrength
const passwordMatchValidator = passwordMatch('password')
const selector = formValueSelector(formName)

const ConfirmPassword = ({
	handleSubmit,
	intl,
	submitRequest,
	changeCode,
	changeEmail,
	changeOriginalEmail,
	location,
	wrongCode,
	originalEmail,
	resetWrongCodeError,
	teamBackground,
	loadTeamBackground,
	teamBackgroundIsLoading,
	teamLogo,
	teamLogoIsLoading,
	loadTeamLogo
}) => {
	const onSubmitForm = (values) => {
		submitRequest(values.email, values.code, values.password)
	}

	useEffect(() => {
		let params = queryString.parse(location.search)
		resetWrongCodeError()

		if (params.code) {
			changeCode(params.code)
		}
		if (params.email) {
			changeEmail(params.email)
			changeOriginalEmail(params.email)
		}
	}, [])

	useEffect(() => {
		if (originalEmail) {
			loadTeamBackground(originalEmail)
			loadTeamLogo(originalEmail)
		}
	}, [originalEmail])

	return (
		<LoginPagesWrapper
			logoUrl={teamLogo || !teamLogoIsLoading && defaultLogo}
			backgroundUrl={teamBackground || !teamBackgroundIsLoading && defaultBackground}
			canChangeLanguage={false}
		>
			<form onSubmit={handleSubmit(onSubmitForm)}
				data-testid='form-confirm'
				style={{ display: 'flex', justifyContent: 'center', width: '90%', margin: '10vh auto 4rem' }}>
				<Paper style={{ maxWidth: '479px', width: '100%', padding: '4rem', margin: '0 auto' }} elevation={2}>
					<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
						<Logo />
					</Grid>
					<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
						<Typography variant='h3' style={{ fontWeight: '500' }}>{intl.formatMessage({ id: 'app.confirmPassword.title' })}</Typography>
					</Grid>
					<Grid item style={{ paddingBottom: '40px', paddingTop: '10px', textAlign: 'center' }}>
						<Typography>
							{intl.formatMessage({ id: 'app.confirmPassword.header' })}
						</Typography>
					</Grid>
					<Grid item style={{ width: '100%' }}>
						<FormTextField
							data-testid='form-confirm-input-email'
							label={intl.formatMessage({ id: 'app.email' })}
							fullWidth
							type="text"
							name="email"
							validators={[requiredValidator, emailValidator]}
							variant="filled"
							disabled={true}
						/>
					</Grid>
					<Grid item style={{ width: '100%' }}>
						<FormTextField
							data-testid='form-confirm-input-code'
							label={intl.formatMessage({ id: 'app.confirmPassword.accessCode' }) + '*'}
							fullWidth
							type="number"
							name="code"
							validators={[requiredValidator]}
							customInvalid={wrongCode}
							variant="filled"
						/>
						{wrongCode && (
							<FormHelperText
								data-testid="confirm-input-code-error"
								style={{
									color: 'red',
									marginLeft: '0px',
									marginTop: '-15px',
									marginBottom: '15px',
									padding: '0',
									fontSize: '14px'
								}}>
								{intl.formatMessage({ id: 'app.confirmPassword.wrongCode' })}
							</FormHelperText>
						)}
					</Grid>
					<Grid item style={{ width: '100%' }}>
						<FormPassword
							data-testid='form-confirm-input-password'
							label={intl.formatMessage({ id: 'app.password' })}
							fullWidth
							name="password"
							validators={[requiredValidator, passwordStrengthValidator]}
							variant="filled"
						/>
					</Grid>
					<Grid item style={{ width: '100%' }}>
						<FormPassword
							data-testid='form-confirm-input-reenter'
							label={intl.formatMessage({ id: 'app.confirmPassword' })}
							fullWidth
							name="confirmPassword"
							validators={[required, passwordMatchValidator]}
							variant="filled"
						/>
					</Grid>
					<Grid item style={{ alignSelf: 'flex-start' }}>
						<LinkButton
							data-testid='form-confirm-link-return'
							textId="app.forgotPassword.returnToLoginButtonText"
							variant="contained"
							color="black"
							backgroundColor="#007aff"
							path="/auth/login"
						/>
					</Grid>
					<Grid item style={{ paddingTop: '20px', textAlign: 'center' }}>
						<Button
							textId="app.confirmPassword.buttonText"
							variant="contained" color="primary"
							type="submit"
							data-testid='form-confirm-button-submit'
						/>
					</Grid>
				</Paper>
			</form>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state) => ({
	wrongCode: wrongCodeErrorSelector(state),
	originalEmail: selector(state, 'originalEmail'),
	teamBackground: teamBackgroundSelector(state),
	teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state),
    teamLogo: teamLogoSelector(state),
    teamLogoIsLoading: teamLogoIsLoadingSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	changeCode: (code) => dispatch(change(formName, 'code', code)),
	changeEmail: (email) => dispatch(change(formName, 'email', email)),
	changeOriginalEmail: (email) => dispatch(change(formName, 'originalEmail', email)),
	submitRequest: (email, code, password) => dispatch(confirmForgotPasswordEmail(email, code, password)),
	resetWrongCodeError: () => dispatch(resetWrongCodeError()),
	loadTeamBackground: (email) => dispatch(getTeamBackgroundByEmail(email)),
	loadTeamLogo: (email) => dispatch(getTeamLogoByEmail(email))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: formName
	})
)

export default enhance(ConfirmPassword)
